export default "__VITE_ASSET__DDY2rqIo__"